import React, { useState } from "react";
import BulkCancellation from "./components/BulkCancellation";
import ManualCancellation from "./components/ManualCancellation";
import { useTranslation } from "react-i18next";
import "./styles/pre-auth.css";

function CancellationList(props) {
  const [totalList, setTotalList] = useState(0);
  const [activeTab, setActiveTab] = useState("bulk");
  const [showLoader, setShowLoader] = useState(false);
  const { t } = useTranslation();

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  return (
    <>
      <div className="pre_auth_container !p-0">
        <div className="my-2">
          <ul className="grid grid-flow-col text-center text-gray-500 bg-gray-100 rounded-lg p-1 shadow-inner">
            <li>
              <a
                className={`flex justify-center py-0.5 cursor-pointer hover:text-primary text-[13px] ${
                  activeTab === "bulk"
                    ? "bg-[#0070C2] rounded-lg !text-white"
                    : ""
                }`}
                onClick={() => handleTabClick("bulk")}
              >
                {t("Bulk Cancellation")}
              </a>
            </li>
            <li>
              <a
                className={`flex justify-center py-0.5 cursor-pointer hover:text-primary text-[13px] ${
                  activeTab === "manual"
                    ? "bg-[#0070C2] rounded-lg !text-white"
                    : ""
                }`}
                onClick={() => handleTabClick("manual")}
              >
                {t("Manual Cancellation")}
              </a>
            </li>
          </ul>
        </div>

        <div className="!mt-2">
          {activeTab === "bulk" && (
            <BulkCancellation
              setShowLoader={setShowLoader}
              showLoader={showLoader}
              setTotslList={setTotalList}
            />
          )}
          {activeTab === "manual" && (
            <ManualCancellation
              setShowLoader={setShowLoader}
              showLoader={showLoader}
              setTotslList={setTotalList}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default CancellationList;
